import {BaseApi, BaseApiV2} from "@newview/infrastructure";
export abstract class NewviewOaBaseApi extends BaseApiV2 {
    public get ProxyName(): any {
        return 'NewviewOaBaseApi';
    }

    constructor() {
        super();
        this.addHeader("ESIndex", "oa_worklog_index");
    }
}
